import React, { useState, useEffect } from 'react';
import { Button } from 'components/shared/ButtonComponent';
import { CheckCircleOutlined, DeleteFilled, RiseOutlined, WarningOutlined, PauseOutlined, PlayCircleOutlined, CloseOutlined } from 'components/shared/AntIcons';
import Chart from "react-apexcharts";
import { ApexOptions } from 'apexcharts';
import IndividualJob from './sub-screens/IndividualJob';

const JobHealthMonitorNew: React.FC = () => {
    const statItems = [
        { id: 1, title: "Active Jobs", count: 2, icon: <CheckCircleOutlined className='text-success' />, color: 'text-success', bgcolor: '#10b77f1a', },
        { id: 2, title: "Total Runs (24h)", count: 21, icon: <RiseOutlined className='text-blue' />, color: 'text-blue', bgcolor: '#1a6ef41a', },
        { id: 3, title: "Failed Runs", count: 2, icon: <WarningOutlined className="text-danger" />, color: 'text-danger', bgcolor: '#ef43431a', },
        { id: 4, title: "Avg Success Rate", count: "96.0%", icon: <RiseOutlined className='text-blue' />, color: 'text-blue', bgcolor: '#1a6ef41a', }
    ];
    const timelineData = Array.from({ length: 24 }, (_, i) => ({
        hour: `${String(i).padStart(2, "0")}:00`,
        "Invoice Sync": Math.floor(Math.random() * 3) + (i % 3 === 0 ? 0 : 1),
        "Payment Reconciliation": i % 2 === 0 ? 1 : 0,
        "Tenant Data Export": i % 4 === 0 ? 1 : 0,
        "Report Generator": i % 6 === 0 ? 1 : 0,
        "Notification Dispatcher": Math.floor(Math.random() * 4) + 1,
    }));
    const jobs = [
        {
            id: "job-1",
            name: "Invoice Sync",
            status: "running",
            lastRun: "2 min ago",
            nextRun: "In 58 min",
            avgDuration: "4m 32s",
            successRate: 98.5,
            runs: [
                { id: "r1", startTime: "00:00", endTime: "00:04", status: "completed", duration: "4m 12s", records: 1240, errors: 0, logs: ["Started sync process", "Connected to billing API", "Fetched 1240 records", "All records synced successfully"] },
                { id: "r2", startTime: "01:00", endTime: "01:05", status: "completed", duration: "4m 45s", records: 1180, errors: 2, logs: ["Started sync process", "Connected to billing API", "2 records failed validation", "1178 records synced"] },
                { id: "r3", startTime: "02:00", endTime: "02:04", status: "completed", duration: "4m 02s", records: 1320, errors: 0, logs: ["Started sync process", "Full sync completed"] },
                { id: "r4", startTime: "03:00", endTime: "03:04", status: "failed", duration: "3m 58s", records: 0, errors: 1, logs: ["Started sync process", "Connection timeout", "Retrying...", "Failed after 3 retries"] },
                { id: "r5", startTime: "04:00", endTime: "04:05", status: "completed", duration: "4m 33s", records: 1290, errors: 0, logs: ["Started sync process", "Recovery successful", "All records synced"] },
                { id: "r6", startTime: "05:00", endTime: "05:04", status: "completed", duration: "4m 20s", records: 1310, errors: 1, logs: ["Sync completed with 1 warning"] },
            ],
            throughputData: [
                { time: "00:00", value: 1240 }, { time: "01:00", value: 1180 }, { time: "02:00", value: 1320 },
                { time: "03:00", value: 0 }, { time: "04:00", value: 1290 }, { time: "05:00", value: 1310 },
                { time: "06:00", value: 1280 }, { time: "07:00", value: 1350 }, { time: "08:00", value: 1400 },
            ],
        },
        {
            id: "job-2",
            name: "Payment Reconciliation",
            status: "completed",
            lastRun: "15 min ago",
            nextRun: "In 45 min",
            avgDuration: "8m 15s",
            successRate: 100,
            runs: [
                { id: "r1", startTime: "00:00", endTime: "00:08", status: "completed", duration: "8m 10s", records: 540, errors: 0, logs: ["Reconciliation started", "Matched 540 payments", "All cleared"] },
                { id: "r2", startTime: "01:00", endTime: "01:08", status: "completed", duration: "8m 22s", records: 520, errors: 0, logs: ["Reconciliation started", "Matched 520 payments"] },
                { id: "r3", startTime: "02:00", endTime: "02:08", status: "completed", duration: "8m 05s", records: 560, errors: 0, logs: ["Full reconciliation complete"] },
                { id: "r4", startTime: "03:00", endTime: "03:09", status: "completed", duration: "8m 30s", records: 510, errors: 0, logs: ["Reconciliation complete"] },
            ],
            throughputData: [
                { time: "00:00", value: 540 }, { time: "01:00", value: 520 }, { time: "02:00", value: 560 },
                { time: "03:00", value: 510 }, { time: "04:00", value: 550 }, { time: "05:00", value: 530 },
                { time: "06:00", value: 570 }, { time: "07:00", value: 545 }, { time: "08:00", value: 560 },
            ],
        },
        {
            id: "job-3",
            name: "Tenant Data Export",
            status: "failed",
            lastRun: "32 min ago",
            nextRun: "Retry in 5 min",
            avgDuration: "12m 45s",
            successRate: 85.2,
            runs: [
                { id: "r1", startTime: "00:00", endTime: "00:12", status: "completed", duration: "12m 30s", records: 3200, errors: 0, logs: ["Export started", "3200 tenant records exported"] },
                { id: "r2", startTime: "02:00", endTime: "02:13", status: "completed", duration: "12m 55s", records: 3180, errors: 5, logs: ["Export started", "5 records skipped", "3175 exported"] },
                { id: "r3", startTime: "04:00", endTime: "04:06", status: "failed", duration: "5m 40s", records: 0, errors: 1, logs: ["Export started", "Storage quota exceeded", "Export aborted"] },
                { id: "r4", startTime: "06:00", endTime: "06:13", status: "completed", duration: "12m 48s", records: 3220, errors: 0, logs: ["Quota cleared", "Export completed"] },
            ],
            throughputData: [
                { time: "00:00", value: 3200 }, { time: "02:00", value: 3180 }, { time: "04:00", value: 0 },
                { time: "06:00", value: 3220 }, { time: "08:00", value: 3250 }, { time: "10:00", value: 3190 },
                { time: "12:00", value: 3300 }, { time: "14:00", value: 3210 }, { time: "16:00", value: 3280 },
            ],
        },
        {
            id: "job-4",
            name: "Report Generator",
            status: "paused",
            lastRun: "1 hr ago",
            nextRun: "Paused",
            avgDuration: "6m 20s",
            successRate: 96.7,
            runs: [
                { id: "r1", startTime: "00:00", endTime: "00:06", status: "completed", duration: "6m 15s", records: 48, errors: 0, logs: ["Generated 48 reports", "All delivered via email"] },
                { id: "r2", startTime: "04:00", endTime: "04:06", status: "completed", duration: "6m 28s", records: 52, errors: 1, logs: ["Generated 52 reports", "1 failed to deliver"] },
                { id: "r3", startTime: "08:00", endTime: "08:07", status: "completed", duration: "6m 18s", records: 45, errors: 0, logs: ["All reports generated"] },
            ],
            throughputData: [
                { time: "00:00", value: 48 }, { time: "04:00", value: 52 }, { time: "08:00", value: 45 },
                { time: "12:00", value: 50 }, { time: "16:00", value: 47 }, { time: "20:00", value: 55 },
            ],
        },
        {
            id: "job-5",
            name: "Notification Dispatcher",
            status: "running",
            lastRun: "5 min ago",
            nextRun: "In 10 min",
            avgDuration: "1m 45s",
            successRate: 99.8,
            runs: [
                { id: "r1", startTime: "00:00", endTime: "00:02", status: "completed", duration: "1m 42s", records: 890, errors: 0, logs: ["Dispatched 890 notifications", "All delivered"] },
                { id: "r2", startTime: "00:15", endTime: "00:17", status: "completed", duration: "1m 48s", records: 920, errors: 1, logs: ["920 notifications queued", "1 bounce detected"] },
                { id: "r3", startTime: "00:30", endTime: "00:32", status: "completed", duration: "1m 40s", records: 875, errors: 0, logs: ["All notifications sent"] },
                { id: "r4", startTime: "00:45", endTime: "00:47", status: "completed", duration: "1m 50s", records: 910, errors: 0, logs: ["Dispatch complete"] },
            ],
            throughputData: [
                { time: "00:00", value: 890 }, { time: "00:15", value: 920 }, { time: "00:30", value: 875 },
                { time: "00:45", value: 910 }, { time: "01:00", value: 940 }, { time: "01:15", value: 860 },
                { time: "01:30", value: 900 }, { time: "01:45", value: 930 }, { time: "02:00", value: 895 },
            ],
        },
    ];
    const rawData = timelineData;

    const keys = Object.keys(rawData[0]).filter(k => k !== "hour");

    const paddedCategories: any = [];
    const paddedSeries: any = keys.map(k => ({ name: k, data: [] }));

    rawData.forEach((item) => {
        // empty before
        paddedCategories.push("");
        keys.forEach((k, si) => paddedSeries[si].data.push(0));

        // real data
        paddedCategories.push(item.hour);
        keys.forEach((k, si) => paddedSeries[si].data.push(item[k]));

        // empty after
        paddedCategories.push("");
        keys.forEach((k, si) => paddedSeries[si].data.push(0));
    });
    const options: ApexOptions = {
        series: paddedSeries,
        colors: ['#a855f7', '#3c83f6', '#f59f0a', '#ef4343', '#16a249'],
        chart: {
            type: 'bar',
            height: 300,
            stacked: true,
            width: '100%',
            toolbar: { show: false },
            zoom: { enabled: false },
            events: {
                mouseMove: (event: any, chartContext: any, config: any) => {

                    const dataPointIndex = config?.dataPointIndex;

                    // ❗ If not hovering on a bar, skip
                    if (dataPointIndex === -1) return;

                    const labels = chartContext?.w?.globals?.labels;
                    const series = chartContext?.w?.globals?.series;
                    const seriesNames = chartContext?.w?.globals?.seriesNames;

                    // 🔥 Find nearest REAL index (skip padded '')
                    let realIndex = dataPointIndex;

                    if (!labels[realIndex]) {
                        for (let i = 1; i <= 2; i++) {
                            if (labels[dataPointIndex - i]) {
                                realIndex = dataPointIndex - i;
                                break;
                            }
                            if (labels[dataPointIndex + i]) {
                                realIndex = dataPointIndex + i;
                                break;
                            }
                        }
                    }

                    const hour = labels[realIndex];
                    if (!hour) return;

                    // 🔥 Get ALL series values at that index
                    const values = seriesNames.map((name: string, i: number) => ({
                        name,
                        value: series[i][realIndex] ?? 0
                    }));

                    // 👉 Example: log or use in UI
                    console.log('Hovered Hour:', hour);
                    console.log('All Values:', values);

                    // 👉 Example: store for external tooltip / UI panel
                    // this.ngZone.run(() => {
                    //   this.hoverData = { hour, values };
                    // });

                }
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '60%',              // ✅ 60% of the now-smaller padded slot
                // borderRadius: 10,
                // endingShape: 'rounded'
            }
        },
        dataLabels: { enabled: false },
        stroke: { curve: 'smooth', width: 0 },  // ✅ width: 0 important for stacked bars
        grid: {
            show: true,
            // bottom: 20,
            borderColor: '#e3e3e3',
            padding: { top: 15 },
            xaxis: { lines: { show: false } },
            yaxis: { lines: { show: false } }
        },
        xaxis: {
            type: 'category',
            categories: paddedCategories,
            crosshairs: {
                show: true,
                width: 3,   // ✅ covers the full 3-slot group width visually
                position: 'back',
                stroke: {
                    color: '#e5e7eb',
                    width: 40,   // ✅ wide crosshair covers all 3 padding slots
                    dashArray: 0,
                },
            },
            labels: {
                rotate: 0,
                hideOverlappingLabels: false,          // ✅ CRITICAL — stop ApexCharts skipping labels
                showDuplicates: false,
                formatter: (val: string) => val || '',
                style: {
                    fontSize: '10px',
                }
            },
            axisTicks: { show: false },
            tooltip: { enabled: false }
        },
        legend: {
            position: 'bottom',
            horizontalAlign: 'center',
            // offsetY: 25,
            markers: {
                shape: 'circle',
                size: 4,
            }
        },
        fill: { opacity: 1 },
        tooltip: {
            enabled: true,
            shared: false,
            intersect: true,
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                console.log("series", series, seriesIndex, dataPointIndex, w)
                return '<div class="arrow_box">' +
                    '<span>' + series[seriesIndex][dataPointIndex] + '</span>' +
                    '</div>'

            }
        }
    }
    return (
        <div className='p-2'>
            <div className="d-flex grid-title-card">
                <h5 className="my-auto ">Job Health Monitor</h5>
                <div className="ms-auto d-flex">
                    {/* <Input
                        prefix={<img src={SearchIcon} height="14px" onClick={() => searchbyBtn()} />}
                        onKeyDown={(e) => handleSearch(e)}
                        value={searchTableVal}
                        onChange={(e) => setsearchTableval(e.target.value)}
                        onKeyUp={(e) => resetSearch(e)}
                        className="search-input col px-2 rounded fs-14"
                        placeholder="Search"
                    /> */}
                    {/* {(userRole == 'researcher' || userProfileInfo?.data?.sub_roll == 'researcher') ? "" : <Tooltip title="Add New Patient" > */}
                    <Button type="primary" className='ms-2' >
                        Refresh
                    </Button>
                    {/* </Tooltip>} */}
                </div>
            </div>
            <div className="my-2">
                <div className="row mx-0 mb-1 dash-cards dash-cards1">
                    {statItems?.map((item: any) => {
                        return (
                            <div className={`col ps-0 dashboard-cards ${item.id == 4 ? 'pe-0' : ''}`} key={item.id}>
                                <div className="p-2 w-100 rounded d-flex bg-white border shadow-sm">
                                    <div className={`${item.color} icon-cont col-auto px-2 my-2 py-2 rounded-circle ms-3`} style={{ backgroundColor: item.bgcolor }}>
                                        {item.icon}
                                    </div>
                                    <div className="m-auto">
                                        <h4 className="text-dark mb-1">{item.count}</h4>
                                        <span className="text-muted w-75 fs-15 fw-bold">{item.title}</span>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className="my-2 p-3 bg-white">
                <h6>Job Execution - Last 24 hours</h6>
                <Chart options={options} series={paddedSeries} type="bar" height={300} />
            </div>
            <div className='row mx-0'>
                {/* {jobs?.map((itm: any) => { */}
                    <IndividualJob jobs={jobs} />
                {/* })} */}
            </div>

        </div>
    )
}

export default JobHealthMonitorNew;